//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconRatingThumbsBoth(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M16 12H23V10H15L11 14.81V17.5C11 18.0304 11.2107 18.5391 11.5858 18.9142C11.9609 19.2893 12.4696 19.5 13 19.5H16V21C16 21.5304 16.2107 22.0391 16.5858 22.4142C16.9609 22.7893 17.4696 23 18 23H19L23 18.24V14H21V17.51L18.0699 21H18V17.5H13V15.5L16 12ZM13 6.5C13 5.96957 12.7893 5.46086 12.4142 5.08578C12.0391 4.71071 11.5304 4.5 11 4.5H8V3C8 2.46957 7.78926 1.96086 7.41418 1.58578C7.03911 1.21071 6.53043 1 6 1H5L1 5.76001V10H3V6.48999L5.93005 3H6V6.5H11V8.5L8 12.03H1V14.03H9L13 9.22V6.5Z" fill="currentColor" /></svg>;
}
export default IconRatingThumbsBoth;